/**
 * Check is a string value is null/undefined or empty 
 * (meaning string has all whitespace removed and length is checked)
 * 
 * @param value string to interrogate
 * @returns boolean
 */
export function isNullOrEmpty(value: string) {
    return !value || value.trim().length === 0;
}